// Shared number formatting helpers for the dashboard.
//
// fmtDec: decimal rule for percentages / ratios / multiples (NOT dollar amounts,
// NOT geometry). Show 1 decimal when |value| >= 1, and 2 decimals when |value| < 1.
//   12.4  -> "12.4"      0.95 -> "0.95"      1 -> "1.0"      -0.3 -> "-0.30"
export function fmtDec(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toFixed(Math.abs(n) < 1 ? 2 : 1);
}

// Same rule, but returns a Number (useful when a numeric value is needed).
export function roundDec(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return n;
  return Number(n.toFixed(Math.abs(n) < 1 ? 2 : 1));
}
